<template>
  <settings-screen title="General">
    <settings-preference-table title="Storage">
      <settings-preference-table-entry label="Provider">
        <base-select v-model="storageProvider">
          <option
              v-for="option of storageProviderOptions"
              :key="option"
              :value="option">
            {{ option | preferenceStorageProvider }}
          </option>
        </base-select>
      </settings-preference-table-entry>
    </settings-preference-table>
  </settings-screen>
</template>

<script>
import PreferenceSchema from '@/preferenceSchema';

import BaseSelect from '@/components/core/BaseSelect.vue';
import SettingsPreferenceTable from '@/components/settings/SettingsPreferenceTable.vue';
import SettingsPreferenceTableEntry from '@/components/settings/SettingsPreferenceTableEntry.vue';
import SettingsScreen from '@/components/settings/SettingsScreen.vue';

import { mapPreference } from '@/helpers/preferences';

export default {
  name: 'GeneralSettings',
  components: {
    BaseSelect,
    SettingsPreferenceTable,
    SettingsPreferenceTableEntry,
    SettingsScreen,
  },
  computed: {
    storageProvider: mapPreference('STORAGE_PROVIDER'),
  },
  data() {
    return {
      storageProviderOptions: PreferenceSchema.STORAGE_PROVIDER.values,
    };
  },
  watch: {
    storageProvider() {
      this.$store.commit('setRouteQuery', null);
      this.$store.commit('notes/setCurrentNote', null);
    },
  },
};
</script>
